// #region AUTH

export const AUTH = {
  AUTH_LOGIN_REQUEST: "AUTH_LOGIN_REQUEST",
  AUTH_LOGIN_SUCCESS: "AUTH_LOGIN_SUCCESS",
  AUTH_LOGIN_FAIL: "AUTH_LOGIN_FAIL",

  AUTH_LOGOUT: "AUTH_LOGOUT",

  AUTH_IS_VALID_TOKEN_REQUEST: "AUTH_IS_VALID_TOKEN_REQUEST",
  AUTH_IS_VALID_TOKEN_SUCCESS: "AUTH_IS_VALID_TOKEN_SUCCESS",
  AUTH_IS_VALID_TOKEN_FAIL: "AUTH_IS_VALID_TOKEN_FAIL",
};

// #endregion

// #region USER

export const USER = {
  USER_GET_REQUEST: "USER_GET_REQUEST",
  USER_GET_SUCCESS: "USER_GET_SUCCESS",
  USER_GET_FAIL: "USER_GET_FAIL",

  USER_UPDATE_REQUEST: "USER_UPDATE_REQUEST",
  USER_UPDATE_SUCCESS: "USER_UPDATE_SUCCESS",
  USER_UPDATE_FAIL: "USER_UPDATE_FAIL",

  USER_PASSWORD_UPDATE_REQUEST: "USER_UPDATE_PASSWORD_REQUEST",
  USER_PASSWORD_UPDATE_SUCCESS: "USER_PASSWORD_UPDATE_SUCCESS",
  USER_PASSWORD_UPDATE_FAIL: "USER_PASSWORD_UPDATE_FAIL",

  USER_CREATE_PASSWORD_REQUEST: "USER_CREATE_PASSWORD_REQUEST",
  USER_CREATE_PASSWORD_SUCCESS: "USER_CREATE_PASSWORD_SUCCESS",
  USER_CREATE_PASSWORD_FAIL: "USER_CREATE_PASSWORD_FAIL",

  USER_SEND_PASSWORD_RECOVERY_EMAIL_REQUEST:
    "USER_SEND_PASSWORD_RECOVERY_EMAIL_REQUEST",
  USER_SEND_PASSWORD_RECOVERY_EMAIL_SUCCESS:
    "USER_SEND_PASSWORD_RECOVERY_EMAIL_SUCCESS",
  USER_SEND_PASSWORD_RECOVERY_EMAIL_FAIL:
    "USER_SEND_PASSWORD_RECOVERY_EMAIL_FAIL",

  USER_GET_APP_SETTINGS_REQUEST: "USER_GET_APP_SETTINGS_REQUEST",
  USER_GET_APP_SETTINGS_SUCCESS: "USER_GET_APP_SETTINGS_SUCCESS",
  USER_GET_APP_SETTINGS_FAIL: "USER_GET_APP_SETTINGS_FAIL",

  USER_UPDATE_APP_SETTINGS_REQUEST: "USER_UPDATE_APP_SETTINGS_REQUEST",
  USER_UPDATE_APP_SETTINGS_SUCCESS: "USER_UPDATE_APP_SETTINGS_SUCCESS",
  USER_UPDATE_APP_SETTINGS_FAIL: "USER_UPDATE_APP_SETTINGS_FAIL",
};

// #endregion

// #region COMPANY

export const COMPANY = {
  COMPANY_GET_COMPANIES_REQUEST: "COMPANY_GET_COMPANIES_REQUEST",
  COMPANY_GET_COMPANIES_SUCCESS: "COMPANY_GET_COMPANIES_SUCCESS",
  COMPANY_GET_COMPANIES_FAIL: "COMPANY_GET_COMPANIES_FAIL",

  COMPANY_DELETE_REQUEST: "COMPANY_DELETE_REQUEST",
  COMPANY_DELETE_SUCCESS: "COMPANY_DELETE_SUCCESS",
  COMPANY_DELETE_FAIL: "COMPANY_DELETE_FAIL",

  COMPANY_ASSIGN_EMPLOYEE_REQUEST: "COMPANY_ASSIGN_EMPLOYEE_REQUEST",
  COMPANY_ASSIGN_EMPLOYEE_SUCCESS: "COMPANY_ASSIGN_EMPLOYEE_SUCCESS",
  COMPANY_ASSIGN_EMPLOYEE_FAIL: "COMPANY_ASSIGN_EMPLOYEE_FAIL",

  COMPANY_GET_COMPANY_EMPLOYEES_REQUEST:
    "COMPANY_GET_COMPANY_EMPLOYEES_REQUEST",
  COMPANY_GET_COMPANY_EMPLOYEES_SUCCESS:
    "COMPANY_GET_COMPANY_EMPLOYEES_SUCCESS",
  COMPANY_GET_COMPANY_EMPLOYEES_FAIL: "COMPANY_GET_COMPANY_EMPLOYEES_FAIL",

  COMPANY_GET_COMPANY_EMPLOYEE_REQUEST: "COMPANY_GET_COMPANY_EMPLOYEE_REQUEST",
  COMPANY_GET_COMPANY_EMPLOYEE_SUCCESS: "COMPANY_GET_COMPANY_EMPLOYEE_SUCCESS",
  COMPANY_GET_COMPANY_EMPLOYEE_FAIL: "COMPANY_GET_COMPANY_EMPLOYEE_FAIL",

  COMPANY_UPDATE_COMPANY_EMPLOYEE_REQUEST:
    "COMPANY_UPDATE_COMPANY_EMPLOYEE_REQUEST",
  COMPANY_UPDATE_COMPANY_EMPLOYEE_SUCCESS:
    "COMPANY_UPDATE_COMPANY_EMPLOYEE_SUCCESS",
  COMPANY_UPDATE_COMPANY_EMPLOYEE_FAIL: "COMPANY_UPDATE_COMPANY_EMPLOYEE_FAIL",

  COMPANY_DELETE_COMPANY_EMPLOYEE_REQUEST:
    "COMPANY_DELETE_COMPANY_EMPLOYEE_REQUEST",
  COMPANY_DELETE_COMPANY_EMPLOYEE_SUCCESS:
    "COMPANY_DELETE_COMPANY_EMPLOYEE_SUCCESS",
  COMPANY_DELETE_COMPANY_EMPLOYEE_FAIL: "COMPANY_DELETE_COMPANY_EMPLOYEE_FAIL",

  COMPANY_GET_SCHEDULE_REQUEST: "COMPANY_GET_SCHEDULE_REQUEST",
  COMPANY_GET_SCHEDULE_SUCCESS: "COMPANY_GET_SCHEDULE_SUCCESS",
  COMPANY_GET_SCHEDULE_FAIL: "COMPANY_GET_SCHEDULE_FAIL",
};

// #endregion

// #region EMPLOYEE

export const EMPLOYEE = {
  EMPLOYEE_CREATE_REQUEST: "EMPLOYEE_CREATE_REQUEST",
  EMPLOYEE_CREATE_SUCCESS: "EMPLOYEE_CREATE_SUCCESS",
  EMPLOYEE_CREATE_FAIL: "EMPLOYEE_CREATE_FAIL",

  EMPLOYEE_GET_EMPLOYEES_REQUEST: "EMPLOYEE_GET_EMPLOYEES_REQUEST",
  EMPLOYEE_GET_EMPLOYEES_SUCCESS: "EMPLOYEE_GET_EMPLOYEES_SUCCESS",
  EMPLOYEE_GET_EMPLOYEES_FAIL: "EMPLOYEE_GET_EMPLOYEES_FAIL",

  EMPLOYEE_GET_REQUEST: "EMPLOYEE_GET_REQUEST",
  EMPLOYEE_GET_SUCCESS: "EMPLOYEE_GET_SUCCESS",
  EMPLOYEE_GET_FAIL: "EMPLOYEE_GET_FAIL",

  EMPLOYEE_UPDATE_REQUEST: "EMPLOYEE_UPDATE_REQUEST",
  EMPLOYEE_UPDATE_SUCCESS: "EMPLOYEE_UPDATE_SUCCESS",
  EMPLOYEE_UPDATE_FAIL: "EMPLOYEE_UPDATE_FAIL",

  EMPLOYEE_DELETE_REQUEST: "EMPLOYEE_DELETE_REQUEST",
  EMPLOYEE_DELETE_SUCCESS: "EMPLOYEE_DELETE_SUCCESS",
  EMPLOYEE_DELETE_FAIL: "EMPLOYEE_DELETE_FAIL",

  EMPLOYEE_CHECK_EXISTENCE_REQUEST: "EMPLOYEE_CHECK_EXISTENCE_REQUEST",
  EMPLOYEE_CHECK_EXISTENCE_SUCCESS: "EMPLOYEE_CHECK_EXISTENCE_SUCCESS",
  EMPLOYEE_CHECK_EXISTENCE_FAIL: "EMPLOYEE_CHECK_EXISTENCE_FAIL",

  EMPLOYEE_GET_COMPANIES_REQUEST: "EMPLOYEE_GET_COMPANIES_REQUEST",
  EMPLOYEE_GET_COMPANIES_SUCCESS: "EMPLOYEE_GET_COMPANIES_SUCCESS",
  EMPLOYEE_GET_COMPANIES_FAIL: "EMPLOYEE_GET_COMPANIES_FAIL",

  EMPLOYEE_GET_SCHEDULE_REQUEST: "EMPLOYEE_GET_SCHEDULE_REQUEST",
  EMPLOYEE_GET_SCHEDULE_SUCCESS: "EMPLOYEE_GET_SCHEDULE_SUCCESS",
  EMPLOYEE_GET_SCHEDULE_FAIL: "EMPLOYEE_GET_SCHEDULE_FAIL",

  EMPLOYEE_ACTIVATE_REQUEST: "EMPLOYEE_ACTIVATE_REQUEST",
  EMPLOYEE_ACTIVATE_SUCCESS: "EMPLOYEE_ACTIVATE_SUCCESS",
  EMPLOYEE_ACTIVATE_FAIL: "EMPLOYEE_ACTIVATE_FAIL",

  EMPLOYEE_DEACTIVATE_REQUEST: "EMPLOYEE_DEACTIVATE_REQUEST",
  EMPLOYEE_DEACTIVATE_SUCCESS: "EMPLOYEE_DEACTIVATE_SUCCESS",
  EMPLOYEE_DEACTIVATE_FAIL: "EMPLOYEE_DEACTIVATE_FAIL",
};

// #endregion

// #region COMPANY_EMPLOYEE

export const COMPANY_EMPLOYEE = {
  COMPANY_EMPLOYEE_GET_SCHEDULE_REQUEST:
    "COMPANY_EMPLOYEE_GET_SCHEDULE_REQUEST",
  COMPANY_EMPLOYEE_GET_SCHEDULE_SUCCESS:
    "COMPANY_EMPLOYEE_GET_SCHEDULE_SUCCESS",
  COMPANY_EMPLOYEE_GET_SCHEDULE_FAIL: "COMPANY_EMPLOYEE_GET_SCHEDULE_FAIL",

  COMPANY_EMPLOYEE_NOTIFY_ERROR_REQUEST:
    "COMPANY_EMPLOYEE_NOTIFY_ERROR_REQUEST",
  COMPANY_EMPLOYEE_NOTIFY_ERROR_SUCCESS:
    "COMPANY_EMPLOYEE_NOTIFY_ERROR_SUCCESS",
  COMPANY_EMPLOYEE_NOTIFY_ERROR_FAIL: "COMPANY_EMPLOYEE_NOTIFY_ERROR_FAIL",
};

// #endregion

// #region COMPANYEMPLOYEE_SHIFT

export const COMPANYEMPLOYEE_SHIFT = {
  COMPANYEMPLOYEE_SHIFT_GET_REQUEST: "COMPANYEMPLOYEE_SHIFT_GET_REQUEST",
  COMPANYEMPLOYEE_SHIFT_GET_SUCCESS: "COMPANYEMPLOYEE_SHIFT_GET_SUCCESS",
  COMPANYEMPLOYEE_SHIFT_GET_FAIL: "COMPANYEMPLOYEE_SHIFT_GET_FAIL",

  COMPANYEMPLOYEE_SHIFT_UPDATE_REQUEST: "COMPANYEMPLOYEE_SHIFT_UPDATE_REQUEST",
  COMPANYEMPLOYEE_SHIFT_UPDATE_SUCCESS: "COMPANYEMPLOYEE_SHIFT_UPDATE_SUCCESS",
  COMPANYEMPLOYEE_SHIFT_UPDATE_FAIL: "COMPANYEMPLOYEE_SHIFT_UPDATE_FAIL",

  COMPANYEMPLOYEE_SHIFT_CREATE_REPORT_REQUEST:
    "COMPANYEMPLOYEE_SHIFT_CREATE_REPORT_REQUEST",
  COMPANYEMPLOYEE_SHIFT_CREATE_REPORT_SUCCESS:
    "COMPANYEMPLOYEE_SHIFT_CREATE_REPORT_SUCCESS",
  COMPANYEMPLOYEE_SHIFT_CREATE_REPORT_FAIL:
    "COMPANYEMPLOYEE_SHIFT_CREATE_REPORT_FAIL",
};

// #endregion

// #region SHIFTTYPE

export const SHIFTTYPE = {
  SHIFTTYPE_CREATE_REQUEST: "SHIFTTYPE_CREATE_REQUEST",
  SHIFTTYPE_CREATE_SUCCESS: "SHIFTTYPE_CREATE_SUCCESS",
  SHIFTTYPE_CREATE_FAIL: "SHIFTTYPE_CREATE_FAIL",

  SHIFTTYPE_GET_SHIFTTYPES_REQUEST: "SHIFTTYPE_GET_SHIFTTYPES_REQUEST",
  SHIFTTYPE_GET_SHIFTTYPES_SUCCESS: "SHIFTTYPE_GET_SHIFTTYPES_SUCCESS",
  SHIFTTYPE_GET_SHIFTTYPES_FAIL: "SHIFTTYPE_GET_SHIFTTYPES_FAIL",

  SHIFTTYPE_GET_REQUEST: "SHIFTTYPE_GET_REQUEST",
  SHIFTTYPE_GET_SUCCESS: "SHIFTTYPE_GET_SUCCESS",
  SHIFTTYPE_GET_FAIL: "SHIFTTYPE_GET_FAIL",

  SHIFTTYPE_UPDATE_REQUEST: "SHIFTTYPE_UPDATE_REQUEST",
  SHIFTTYPE_UPDATE_SUCCESS: "SHIFTTYPE_UPDATE_SUCCESS",
  SHIFTTYPE_UPDATE_FAIL: "SHIFTTYPE_UPDATE_FAIL",

  SHIFTTYPE_DELETE_REQUEST: "SHIFTTYPE_DELETE_REQUEST",
  SHIFTTYPE_DELETE_SUCCESS: "SHIFTTYPE_DELETE_SUCCESS",
  SHIFTTYPE_DELETE_FAIL: "SHIFTTYPE_DELETE_FAIL",
};

// #endregion

// #region PROJECT

export const PROJECT = {
  PROJECT_GET_PROJECTS_REQUEST: "PROJECT_GET_PROJECTS_REQUEST",
  PROJECT_GET_PROJECTS_SUCCESS: "PROJECT_GET_PROJECTS_SUCCESS",
  PROJECT_GET_PROJECTS_FAIL: "PROJECT_GET_PROJECTS_FAIL",

  PROJECT_GET_PROJECT_REQUEST: "PROJECT_GET_PROJECT_REQUEST",
  PROJECT_GET_PROJECT_SUCCESS: "PROJECT_GET_PROJECT_SUCCESS",
  PROJECT_GET_PROJECT_FAIL: "PROJECT_GET_PROJECT_FAIL",

  PROJECT_DELETE_REQUEST: "PROJECT_DELETE_REQUEST",
  PROJECT_DELETE_SUCCESS: "PROJECT_DELETE_SUCCESS",
  PROJECT_DELETE_FAIL: "PROJECT_DELETE_FAIL",

  PROJECT_GET_SCHEDULE_REQUEST: "PROJECT_GET_SCHEDULE_REQUEST",
  PROJECT_GET_SCHEDULE_SUCCESS: "PROJECT_GET_SCHEDULE_SUCCESS",
  PROJECT_GET_SCHEDULE_FAIL: "PROJECT_GET_SCHEDULE_FAIL",
};

// #endregion

// #region SHIFT

export const SHIFT = {
  SHIFT_GET_SHIFTS_REQUEST: "SHIFT_GET_SHIFTS_REQUEST",
  SHIFT_GET_SHIFTS_SUCCESS: "SHIFT_GET_SHIFTS_SUCCESS",
  SHIFT_GET_SHIFTS_FAIL: "SHIFT_GET_SHIFTS_FAIL",

  SHIFT_GET_SHIFT_REQUEST: "SHIFT_GET_SHIFT_REQUEST",
  SHIFT_GET_SHIFT_SUCCESS: "SHIFT_GET_SHIFT_SUCCESS",
  SHIFT_GET_SHIFT_FAIL: "SHIFT_GET_SHIFT_FAIL",

  SHIFT_DELETE_REQUEST: "SHIFT_DELETE_REQUEST",
  SHIFT_DELETE_SUCCESS: "SHIFT_DELETE_SUCCESS",
  SHIFT_DELETE_FAIL: "SHIFT_DELETE_FAIL",

  SHIFT_GET_ACTIVE_SHIFTS_REQUEST: "SHIFT_GET_ACTIVE_SHIFTS_REQUEST",
  SHIFT_GET_ACTIVE_SHIFTS_SUCCESS: "SHIFT_GET_ACTIVE_SHIFTS_SUCCESS",
  SHIFT_GET_ACTIVE_SHIFTS_FAIL: "SHIFT_GET_ACTIVE_SHIFTS_FAIL",

  SHIFT_GET_ACTIVE_SHIFT_REQUEST: "SHIFT_GET_ACTIVE_SHIFT_REQUEST",
  SHIFT_GET_ACTIVE_SHIFT_SUCCESS: "SHIFT_GET_ACTIVE_SHIFT_SUCCESS",
  SHIFT_GET_ACTIVE_SHIFT_FAIL: "SHIFT_GET_ACTIVE_SHIFT_FAIL",

  SHIFT_ASSIGN_EMPLOYEES_REQUEST: "SHIFT_ASSIGN_EMPLOYEES_REQUEST",
  SHIFT_ASSIGN_EMPLOYEES_SUCCESS: "SHIFT_ASSIGN_EMPLOYEES_SUCCESS",
  SHIFT_ASSIGN_EMPLOYEES_FAIL: "SHIFT_ASSIGN_EMPLOYEES_FAIL",

  SHIFT_GET_EMPLOYEES_OF_COMPANY_REQUEST:
    "SHIFT_GET_EMPLOYEES_OF_COMPANY_REQUEST",
  SHIFT_GET_EMPLOYEES_OF_COMPANY_SUCCESS:
    "SHIFT_GET_EMPLOYEES_OF_COMPANY_SUCCESS",
  SHIFT_GET_EMPLOYEES_OF_COMPANY_FAIL: "SHIFT_GET_EMPLOYEES_OF_COMPANY_FAIL",

  SHIFT_DUPLICATE_REQUEST: "SHIFT_DUPLICATE_REQUEST",
  SHIFT_DUPLICATE_SUCCESS: "SHIFT_DUPLICATE_SUCCESS",
  SHIFT_DUPLICATE_FAIL: "SHIFT_DUPLICATE_FAIL",
};

// #endregion

// #region SHIFTTYPE_COMPANY

export const SHIFTTYPE_COMPANY = {
  SHIFTTYPE_COMPANY_CREATE_REQUEST: "SHIFTTYPE_CREATE_REQUEST",
  SHIFTTYPE_COMPANY_CREATE_SUCCESS: "SHIFTTYPE_CREATE_SUCCESS",
  SHIFTTYPE_COMPANY_CREATE_FAIL: "SHIFTTYPE_CREATE_FAIL",

  SHIFTTYPE_COMPANY_GET_SHIFTTYPE_COMPANIIES_REQUEST:
    "SHIFTTYPE_COMPANY_GET_SHIFTTYPE_COMPANIIES_REQUEST",
  SHIFTTYPE_COMPANY_GET_SHIFTTYPE_COMPANIIES_SUCCESS:
    "SHIFTTYPE_COMPANY_GET_SHIFTTYPE_COMPANIIES_SUCCESS",
  SHIFTTYPE_COMPANY_GET_SHIFTTYPE_COMPANIIES_FAIL:
    "SHIFTTYPE_COMPANY_GET_SHIFTTYPE_COMPANIIES_FAIL",

  SHIFTTYPE_COMPANY_GET_REQUEST: "SHIFTTYPE_COMPANY_GET_REQUEST",
  SHIFTTYPE_COMPANY_GET_SUCCESS: "SHIFTTYPE_COMPANY_GET_SUCCESS",
  SHIFTTYPE_COMPANY_GET_FAIL: "SHIFTTYPE_COMPANY_GET_FAIL",

  SHIFTTYPE_COMPANY_UPDATE_REQUEST: "SHIFTTYPE_COMPANY_UPDATE_REQUEST",
  SHIFTTYPE_COMPANY_UPDATE_SUCCESS: "SHIFTTYPE_COMPANY_UPDATE_SUCCESS",
  SHIFTTYPE_COMPANY_UPDATE_FAIL: "SHIFTTYPE_COMPANY_UPDATE_FAIL",

  SHIFTTYPE_COMPANY_DELETE_REQUEST: "SHIFTTYPE_COMPANY_DELETE_REQUEST",
  SHIFTTYPE_COMPANY_DELETE_SUCCESS: "SHIFTTYPE_COMPANY_DELETE_SUCCESS",
  SHIFTTYPE_COMPANY_DELETE_FAIL: "SHIFTTYPE_COMPANY_DELETE_FAIL",
};

// #endregion



// WEBPACK FOOTER //
// ./src/actions/types.js